import { mapValues } from 'lodash';
import QUESTION_IDS from '../utils/questionIds';
import Question, { Flow, IQuestion } from './Question';

interface IQuestions {
  [key: string]: IQuestion;
}

export default function useQuestionSet() {
  const Questions: IQuestions = {
    HOME_TYPE: {
      id: QUESTION_IDS.HOME_TYPE,
      slug: 'home-type',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return Questions.HOME_OWNERSHIP;
      },
    },
    HOME_OWNERSHIP: {
      id: QUESTION_IDS.HOME_OWNERSHIP,
      slug: 'home-ownership',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return Questions.ROOM_STATUS;
      },
    },
    HOME_LOCATION: {
      id: QUESTION_IDS.HOME_LOCATION,
      slug: 'home-location',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return Questions.ROOM_STATUS;
      },
    },
    ROOM_STATUS: {
      id: QUESTION_IDS.ROOM_STATUS,
      slug: 'room-status',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return Questions.TIMEFRAME;
      },
    },
    TIMEFRAME: {
      id: QUESTION_IDS.TIMEFRAME,
      slug: 'timeframe',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return Questions.BUDGET;
      },
    },
    BUDGET: {
      id: QUESTION_IDS.BUDGET,
      slug: 'budget',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return null;
      },
    },
    NAME: {
      id: QUESTION_IDS.NAME,
      slug: 'name',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.EMAIL;
      },
    },
    DESIGN_EXPERIENCE: {
      id: QUESTION_IDS.DESIGN_EXPERIENCE,
      slug: 'design-experience',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.ROOM_SELECTION;
      },
    },
    ROOM_SELECTION: {
      id: QUESTION_IDS.ROOM_SELECTION,
      slug: 'room-selection',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.NAME;
      },
    },
    ROOM_FOCUS: {
      id: QUESTION_IDS.ROOM_FOCUS,
      slug: 'room-focus',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.NAME;
      },
    },
    STYLE_INSPIRATION: {
      id: QUESTION_IDS.STYLE_INSPIRATION,
      slug: 'style-inspiration',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.ROOM_SELECTION;
      },
    },
    STYLE_SELECTION: {
      id: QUESTION_IDS.STYLE,
      slug: 'style-selection',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.ROOM_SELECTION;
      },
    },
    EMAIL: {
      id: QUESTION_IDS.EMAIL,
      slug: 'email',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.INTERSTITIAL;
      },
    },
    INTERSTITIAL: {
      id: QUESTION_IDS.INTERSTITIAL,
      slug: 'interstitial',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.STYLE_REVEAL;
      },
    },
    STYLE_REVEAL: {
      id: QUESTION_IDS.STYLE_REVEAL,
      slug: 'style-reveal',
      flow: Flow.YOUR_NEEDS,
      get nextQuestion() {
        return null;
      },
    },
    STYLE_KEYWORDS: {
      id: QUESTION_IDS.STYLE_KEYWORDS,
      slug: 'style-keywords',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.LIFE_EVENTS;
      },
    },
    LIFE_EVENTS: {
      id: QUESTION_IDS.LIFE_EVENTS,
      slug: 'life-events',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.DESIGN_STRUGGLES;
      },
    },
    DESIGN_STRUGGLES: {
      id: QUESTION_IDS.DESIGN_STRUGGLES,
      slug: 'design-struggles',
      flow: Flow.STYLE_QUIZ,
      get nextQuestion() {
        return Questions.HOME_LOCATION;
      },
    },
  };

  return mapValues(Questions, (question: IQuestion) => {
    const mapped = {
      ...question,
      nextQuestion: question.nextQuestion
        ? new Question(question.nextQuestion)
        : null,
    };
    return new Question(mapped);
  });
}
